<template>
<v-container fill-height justify-center align-center >
  <!-- <v-layout row > -->
    <v-flex xs12 sm5 md4 lg3>

      <v-card class="mt-0 pt-0">
          <v-card-title class="blue darken-1">
            <h4 style="color:white">{{pagetitle}}</h4>
          </v-card-title>
          <v-card-text>
              <form @submit.prevent="login">
                <v-layout row wrap>
                  <v-flex  xs12 md8>
                    <v-text-field class="input-group--focused" name="key" v-model="key" label="Key" value="Key""></v-text-field>
                  </v-flex>
                </v-layout>
                <v-btn type="submit">login</v-btn>
                <v-snackbar v-if="error" :timeout="timeout" :top="true" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="error">
                  {{ text }}
                  <v-btn class="pink--text" flat @click.native="error = false">Close</v-btn>
                </v-snackbar>
              </form>
        </v-card-text>
      </v-card>
      <div v-if="isH">
      <br>
      <a href="http://www.iphonefile.com/IMEIMate.exe">Download Windows App</a>
      <br>
      <a href="https://vimeo.com/339872408" target="_blank">Windows App Demo Video</a>
      <br>
      <br>
      <a href="http://hanggroup.com/imeimate/" target="_blank">Purchase Key (Credits)</a>

      <br><br>
      <b> Available Services: </b> <br>
    iPhone Carrier Checker (Full Info)<br>
    iPhone Sim Lock Status<br>
    Find My iPhone ON/OFF by IMEI<br>
    Find My iPhone ON/OFF by SN<br>
    IMEI<->SN Converter<br>
    Activation Check By(IMEI/SN)<br>
    Full Coverage Check By(IMEI/SN)<br>
    iPhone/iPad iCloud Clean/Lost by IMEI<br>
    Sprint USA Pro Check<br>
    iPhone Carrier Checker<br>
    Sprint Unbarring (SPCS: Yes)<br>
    T-Mobile USA Status Check<br>
    WorldWide Clean/Blocked Check GSMA<br>
    Samsung Check
<br><br>
<b> Contact: </b> <br>
      Skype: hangunlock <br>
      QQ: 2476715039 <br>
      Email: sales@hangunlock.com <br>
      WhatsApp / WeChat / iMessage: +85261942922 <br>
      </div>
    </v-flex>
  <!-- </v-layout> -->
  </v-container>
</template>
<script>
import auth from '../utils/auth'

export default {
  data () {
    return {
      pagetitle: '',
      key: '',
      error: false,
      text: '',
      isH: false
    }
  },
  mounted () {
  this.pagetitle = window.location.hostname
  if (this.pagetitle.includes("mate")){
  this.isH = true;
  }
    if (localStorage.userkey.length > 5)
    {
        this.key = localStorage.userkey;
        this.login();
    }
  },
  methods: {
    login () {
      auth.login(this.key, (loggedIn, err) => {
        if (err) {
          // console.log('login', err.response)
          if (localStorage.userkey === this.key)
          {
            localStorage.userkey = null;
          }
          this.error = true
          this.text = err.response.data
        } else if (loggedIn === false) {
          // console.log('login', loggedIn)
          if (localStorage.userkey === this.key)
          {
            localStorage.userkey = null;
          }
          this.error = true
          this.text = 'Bad login information'
        } else {
          // console.log(this.$route)
          localStorage.userkey = this.key;
          this.$router.push(this.$route.query.redirect || '/');

        }
      })
    }
  }
}
</script>
<style lang="stylus">
  @import '../stylus/main'
</style>



// WEBPACK FOOTER //
// Login.vue?69397132